import { Divider, IconButton, Stack, Typography } from "@mzc-pdc/ui";
import { Link } from "react-router-dom";
import theme from "@styles/theme";
import { SquareIcon } from "@components_v2/icon";
import { IconAdd, IconMoreVert, IconOpenInNew, IconRefresh } from "@mzc-cloudplex/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "@components_v2/Tooltip/tooltip";
import { Menu } from "@components_v2/menu/menu";

const WidgetHead = ({ icon, color, title, onRefresh, actionMenus, onMoreView, externalLink, link }) => {
    const { t } = useTranslation();
    return (
        <Stack direction={"row"} alignItems={"center"} px={theme.spacing(2)} py={theme.spacing(1.5)}>
            <Stack direction={"row"} gap={1} flex={1} alignItems={"center"}>
                <SquareIcon width={20} height={16} color={color}>
                    {icon}
                </SquareIcon>
                <Typography variant={"body1_700"}>{t(`common::label::${title}`, title)}</Typography>
                {link && (
                    <Tooltip title={t(`common::label::Add`, `Add`)}>
                        <IconButton circled size={"small"} component={Link} to={link}>
                            <IconAdd size={16} />
                        </IconButton>
                    </Tooltip>
                )}
                {onMoreView && (
                    <Tooltip title={t(`common::label::Add`, `Add`)}>
                        <IconButton circled size={"small"} onClick={onMoreView}>
                            <IconAdd size={10} />
                        </IconButton>
                    </Tooltip>
                )}
                {externalLink && (
                    <a href={externalLink} target={`_blank`} className={"btn btn-icon-solid"}>
                        <IconOpenInNew size={12} />
                    </a>
                )}
            </Stack>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
                <Tooltip title={t("common::label::Refresh", `Refresh`)}>
                    <IconButton circled onClick={onRefresh}>
                        <IconRefresh size={16} />
                    </IconButton>
                </Tooltip>

                {actionMenus && (
                    <>
                        {actionMenus.some((menu) => !menu.disabled) && (
                            <Divider orientation={"vertical"} flexItem sx={{ my: 0.5 }} />
                        )}
                        <Menu
                            menuWidth={160}
                            placement={"bottom"}
                            type={"icon"}
                            label={<IconMoreVert size={16} />}
                            color={"inherit"}
                            size={"medium"}
                            list={actionMenus}
                        />
                    </>
                )}
            </Stack>
        </Stack>
    );
};

export default WidgetHead;
